/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Data_StorageInputs */

const en_ui_data_storage = /** @type {(inputs: Ui_Data_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your data`)
};

const de_ui_data_storage = /** @type {(inputs: Ui_Data_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Daten`)
};

/**
* | output |
* | --- |
* | "Your data" |
*
* @param {Ui_Data_StorageInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_data_storage = /** @type {((inputs?: Ui_Data_StorageInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Data_StorageInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_data_storage(inputs)
	return de_ui_data_storage(inputs)
});